import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {StickerFormatFormComponent} from "../../components/sticker-format-form/sticker-format-form.component";
import {MedicineStickersService} from "../../services/medicine-stickers.service";
import {MessageType} from "../../../shared/redux-store/session";

@Component({
  selector: 'vb-sticker-formats-view',
  templateUrl: './sticker-formats-view.component.html',
  styleUrls: ['./sticker-formats-view.component.css']
})
export class StickerFormatsViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild('addStickerFormatModal')
  addStickerFormatModal: GenericModalComponent;

  currentStickerFormatControl: FormGroup;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private medStickersService: MedicineStickersService,) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Beschriftungsformat hinzufügen',
        icon: 'fa-plus',
        action: () => this.showAddStickerFormatModal.apply(this)
      }
    ]

  }

  showAddStickerFormatModal() {
    this.currentStickerFormatControl = StickerFormatFormComponent.initControl(this.fb);
    this.addStickerFormatModal.show();
  }

  saveStickerFormatClicked() {
    this.medStickersService.createStickerFormat(this.currentStickerFormatControl.value).subscribe(
      res => this.sessionActions.pushMessage("Beschriftungsformat erfolgreich angelegt!", MessageType.SUCCESS, "Beschriftungsformat"),
      err => this.sessionActions.throwError(err, "Fehler beim Anlegen des Beschriftungsformats!"));

  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/view-components/sticker-formats-view/sticker-formats-view.component.ts